import React, { useEffect, useState, useRef, useMemo } from 'react'
import { request } from 'meinian-package/src/utils'
import { Spin } from 'antd'
import { useNavigate } from 'react-router-dom'
import qs from 'qs'
import classNames from 'classnames'
import { Icon } from 'meinian-package/src/component'
import './index.less'
import { useRequest } from 'ahooks'
import HasEmpty from 'component/hasEmpty'

const MARGIN = 8
const COLUMN_NUM = 7
const SCROLLBAR_WIDTH = 5

export const bgColor = (titleValue) => {
  if (titleValue === 'category') return '#FF9000'
  if (titleValue === 'design' || titleValue === 'recent') return '#2CA8FF'
  return 'var(--m-success-normal)'
}

const DesignFilter = ({
  titleValue,
  params,
  options = [],
  onChange,
  value
}) => {
  const has = titleValue === 'design' && params.gender === '鞋靴'
  return <div className="right-filter">
    {has && <span className={classNames('item', { active: value == 8 })} onClick={() => onChange(8)}>跟底</span>}
    {
        !has && options.map(v => <span className={classNames('item', { active: value == v.value })} onClick={() => onChange(v.value)}>{v.label}</span>)
      }
  </div>
}

export const Template = ({
  title,
  titleValue,
  params,
  loading,
  dataList = [],
  filterValue,
  filterOnChange,
  filterOptions,
}) => {
  const [showMore, setShowMore] = useState(false)
  const [itemWidth, setItemWidth] = useState()
  const $list = useRef()
  const history = useNavigate()

  const data = useMemo(() => {
    if (dataList?.length) {
      if (showMore) {
        return dataList?.filter(item => item.totalNumber > 0)
      }
      return dataList?.filter(item => item.totalNumber > 0).filter((_, index) => index < 7 && index >= 0)
    }
    return []
  }, [showMore, dataList])

  useEffect(() => {
    const resizeLayout = () => {
      const WIDTH = $list?.current?.clientWidth
      setItemWidth((WIDTH - (COLUMN_NUM - 1) * MARGIN - SCROLLBAR_WIDTH) / COLUMN_NUM)
    }
    resizeLayout()
    window.addEventListener('resize', resizeLayout, false)
    return () => window.removeEventListener('resize', resizeLayout, false)
  }, [loading, $list])

  const hasLength = (((params.inspirationIdList.length > 0 || params.userIdList.length > 0) && titleValue === 'recent') || !data?.length)

  return <Spin
    spinning={loading}
    indicator={<Icon type="m-jiazaizhong" spin />}
  >
    <HasEmpty length={!hasLength} loading={loading} emptySlot={<div />}>
      <div className="list-wrap">
        <div className="title">
          {title}
          <DesignFilter
            titleValue={titleValue}
            params={params}
            options={filterOptions}
            value={filterValue}
            onChange={filterOnChange}
          />
          <div className="meinian-space" />
          {dataList?.filter(item => item.totalNumber > 0)?.length > 7 && titleValue !== 'recent' ? <div className="fold-btn" onClick={() => setShowMore(!showMore)}><span style={{ marginRight: 3 }}>{showMore ? '收起' : '展开'}</span><Icon type={showMore ? 'm-Vxing_shang' : 'm-Vxing_xia'} /></div> : null}
        </div>
        <div className="content-list-wrap" ref={$list}>
          {data?.map((item, index) => <div className="card-item" style={{ width: itemWidth, height: 88 }} onClick={() => history(`/home/intelligent/detail?${qs.stringify({ rootClassifyName: item.rootClassifyName, classifyName: item.classifyName, type: item.type, params: { ...params, platformId: item.platformId || null } })}`)}>
            {index === 0 ? <div>
              <div className="info-wrap-active" style={{ backgroundImage: `url(${item.imgUrl})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', opacity: 1 }}>
                <div className="hover-mask">
                  <span className="label">{item.classifyName || item.rootClassifyName}</span>
                  <div className="total-num"><span>{item.totalNumber > 999 ? '999+' : item.totalNumber}</span>张</div>
                </div>
              </div>
            </div> : <>
              <div className="info-wrap" style={{ backgroundColor: titleValue === 'color' ? item.color : bgColor(titleValue) }}>
                <div className="mask-1" />
                <div className="mask-2">
                  <span className="label">{item.classifyName || item.rootClassifyName}</span>
                  <div className="total-num"><span>{item.totalNumber > 999 ? '999+' : item.totalNumber}</span>张</div>
                </div>
              </div>
              <div className="info-wrap-active" style={{ backgroundImage: `url(${item.imgUrl})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                <div className="hover-mask">
                  <span className="label">{item.classifyName || data.rootClassifyName}</span>
                  <div className="total-num"><span>{item.totalNumber > 999 ? '999+' : item.totalNumber}</span>张</div>
                </div>
              </div></>}
          </div>)}
        </div>
      </div>
    </HasEmpty>
  </Spin>
}

export default function DesignList(props) {
  const { title, titleValue, params } = props
  const [filterValue, setFilterValue] = useState()

  const { data, loading } = useRequest(async () => {
    const result = await request.post('/zhikuan/intellect-classify/all-design-element-list', { ...params })
    setFilterValue(result?.[0]?.[0]?.type)
    return result || []
  }, {
    refreshDeps: [params],
  })

  const result = useMemo(() => {
    const filterOptions = data?.map(item => ({ label: item[0].rootClassifyName, value: item[0].type, children: item }))
    const dataList = filterOptions?.find(item => item.value === filterValue)?.children
    return {
      dataList,
      filterOptions,
    }
  }, [data, filterValue])

  return <Template
    title={title}
    titleValue={titleValue}
    params={params}
    loading={loading}
    dataList={result.dataList}
    filterOptions={result.filterOptions}
    filterValue={filterValue}
    filterOnChange={val => setFilterValue(val)}
  />
}
